<template>
  <div class="ifInput" ref="r_ifInput" style="position: relative">
    <div class="ifinput-container">
      <textarea
        id="text-elem"
        ref="textarea"
        v-model="message"
        placeholder="Write a message..."
        class="text-e"
        @keydown.enter.prevent="handleEnter"
        @input="updateLineCount"
      ></textarea>
      <div class="sendBox">
        <div class="sendBox-left">
          <!-- 表情 -->
          <span :class="{ hover: enjoy }" @click="inenjoy">
            <i class="bq" :class="{ 'is-active': enjoy }">
              <input style="display: none" />
            </i>
          </span>
          <VEmojiPicker @select="selectEmoji" :show-search="false" v-if="enjoy == true" />

          <!-- 更多 -->
          <span :class="{ hover: moremenu }" @click="viewmore">
            <i class="gd" :class="{ 'is-active': moremenu }"></i>
          </span>
          <div class="menudialog" v-show="moremenu">
            <span @click="sendFile">
              <i class="file">
                <input
                  ref="file"
                  style="display: none"
                  type="file"
                  accept="*.*"
                  @change="onFile"
                />
              </i>
              Send a file
            </span>
            <span @click="sendImage">
              <i class="img">
                <input
                  ref="image"
                  style="display: none"
                  type="file"
                  accept="image/png, image/gif, image/jpeg, image/webp"
                  @change="onImage"
                />
              </i>
              Send a picture
            </span>
          </div>

          <!-- 表单 -->
          <!-- <i class="form"></i> -->

          <!--        <i class="audio" @click="sendAudio">-->
          <!--          <input-->
          <!--            ref="audio"-->
          <!--            style="display: none"-->
          <!--            type="file"-->
          <!--            accept="audio/aac"-->
          <!--            @change="onAudio"-->
          <!--          />-->
          <!--        </i>-->
          <!--        <i class="video" @click="sendVideo">-->
          <!--          <input-->
          <!--            ref="video"-->
          <!--            style="display: none"-->
          <!--            type="file"-->
          <!--            accept="video/mp4"-->
          <!--            @change="onVideo"-->
          <!--          />-->
          <!--        </i>-->
        </div>
        <div
          class="sendBox-right"
          :class="{ success: this.message.length > 0 }"
          @click="sendMsg"
          v-if="disabled == false"
        ></div>
        <div class="sendBox-right disabled" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import markdownIt from "markdown-it";
import { VEmojiPicker } from "v-emoji-picker";
import EventBus from '@/utils/EventBus'
export default {
  name: "SendBox",
  components: {
    VEmojiPicker,
  },
  props: {
    roomName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      message: "",
      isMd: true, // 判断是否为 markdown 文本
      enjoy: false,
      moremenu: false,
      lineCount: 1, // 初始行数

      messagelength: 0, // 字符数量
      replyToId: 0,
    };
  },
  watch: {
    message() {
      let msg = this.message.replace(/[\r\n]/g, "");
      this.$emit("preMsg", { text: msg });
    },
  },
  methods: {
    // Scroll
    scrollMessage() {
      setTimeout(() => {
        let box = document.getElementById("msgList");
        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      }, 200);
    },
    // 表情
    inenjoy() {
      this.enjoy = !this.enjoy;
      this.moremenu = false;
    },
    // 查看更多按钮
    viewmore() {
      this.moremenu = !this.moremenu;
      this.enjoy = false;
    },
    selectEmoji(emoji) {
      this.message = this.message + emoji.data;
      this.enjoy = false;
    },
    // 发送图片
    sendImage() {
      if (this.roomName === "") return;
      this.$refs.image.dispatchEvent(new MouseEvent("click"));
    },
    onImage(e) {
      let file = e.target.files[0];
      if (file.size > 100 * 1024 * 1024) {
        alert("文件发送最大100M！");
        return;
      }
      this.$emit("image", { file: file });
      this.$refs.image.value = "";
      this.scrollMessage();
      this.moremenu = false;
    },
    // 发送文件
    sendFile() {
      if (this.roomName === "") return;
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    onFile(e) {
      let file = e.target.files[0];
      if (file.size > 100 * 1024 * 1024) {
        alert("文件发送最大100M！");
        return;
      }
      this.$emit("file", { file: file });
      this.$refs.file.value = "";
      this.scrollMessage();
      this.moremenu = false;
    },
    sendMsg() {
      this.enjoy = false;
      this.moremenu = false;
      let content = this.message.replace(/[\r\n]/g, "");
      if (content.length == 0) return;
      this.$emit(
        "talk", 
        this.message.replace(/[\r\n]/g, ""), //msg
        '', // msgType
        this.replyToId, // replyToId
      );

      this.message = "";

      var bubbleList = document.querySelector("#jljw_IM_GdImBox .GdImBox .bubbleList");
      bubbleList.style.height = "350px";
      this.$refs.textarea.style.height = "50px";
      this.lineCount = 1;
    },
    handleEnter() {
      if (event.shiftKey) {
        // 如果按住了 Shift 键，执行换行
        this.message += "\n";
      } else {
        // 否则执行发送消息
        if (this.disabled == false) {
          this.sendMsg();
        }
      }
    },
    updateLineCount() {
      this.enjoy = false;
      this.moremenu = false;
      const textarea = this.$refs.textarea;
      // 自动调整高度，使行数计算准确
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight - 10}px`;
      const bubbleList = document.querySelector("#jljw_IM_GdImBox .GdImBox .bubbleList");
      bubbleList.style.height = `${400 - textarea.offsetHeight}px`;
      // 根据高度和行高计算行数
      const lineHeight = parseFloat(window.getComputedStyle(textarea).lineHeight);
      this.lineCount = Math.ceil(textarea.scrollHeight / lineHeight);

      if (this.message.length == 0) {
        this.lineCount = 1;
      }

      // 判断是不是新增内容
      if (this.message.length > this.messagelength) {
        this.scrollToBottom();
      }
      this.messagelength = this.message.length;
    },
    // 滚动textara到底部
    scrollToBottom() {
      const textarea = this.$refs.textarea;
      textarea.scrollTop = textarea.scrollHeight;
    },
  },
  created() {
    // 引用id
    EventBus.$on('replyToId', data => {
      this.replyToId = data;
      this.$refs.textarea.focus();
    })
    // 引导发问
    EventBus.$on('updateTextarea', data => {
      //this.message = data;
      //this.$refs.textarea.focus();
      this.$emit(
        "talk", 
        data, //msg
        '', // msgType
        this.replyToId, // replyToId
      );
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        textarea.scrollTop = textarea.scrollHeight;
      })
    })
  },
  beforeDestroy() {
    EventBus.$off('replyToId');
    EventBus.$off('updateTextarea');
  }
};
</script>
